import { BottomSheet, Text, Title, type UseModalState } from "@clipboard-health/ui-components";
import { getSafeAreaPaddings } from "@clipboard-health/ui-theme";
import { DialogContent, Stack } from "@mui/material";

interface OfflineIndicatorProps {
  modalState: UseModalState;
}

export function OfflineIndicator(props: OfflineIndicatorProps) {
  const { modalState } = props;

  return (
    <BottomSheet
      modalState={modalState}
      paperSx={(theme) => ({
        backgroundColor: theme.palette.intent?.error.backgroundInvert,
        ...getSafeAreaPaddings({ bottom: true, fallbackBottom: theme.spacing(5) }),
      })}
    >
      <DialogContent>
        <Stack spacing={7} sx={{ alignItems: "center", textAlign: "center" }}>
          <Title
            component="h3"
            sx={{ color: (theme) => theme.palette.text.invertPrimary, textWrap: "balance" }}
          >
            Connection lost
          </Title>
          <Text variant="body1" sx={{ color: (theme) => theme.palette.text.invertPrimary }}>
            We can&apos;t reach the servers right now. Check your connection and retry.
          </Text>
        </Stack>
      </DialogContent>
    </BottomSheet>
  );
}
